import React from 'react';
import PropTypes from 'prop-types';

import MaterialUITooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';
import Dagstorp from 'LegacyWeployDesignLanguage/dagstorp';

const styles = {
  tooltip: {
    backgroundColor: Dagstorp.colors.brand.secondary,
    ...Dagstorp.typography.caption,
    color: Theme.colors.primaryOnDark,
    verticalAlign: 'middle',
    display: 'inline-block',
  },
};

const Tooltip = ({
  classes,
  text,
  placement,
  children,
}) => (
  <MaterialUITooltip
    title={text}
    placement={placement}
    classes={{ tooltip: classes.tooltip }}
  >
    <div>{children}</div>
  </MaterialUITooltip>
);

Tooltip.propTypes = {
  placement: PropTypes.string,
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

Tooltip.defaultProps = {
  placement: 'top',
};

export default withStyles(styles)(Tooltip);
